// TODO: Potentially move these colors to the `app.transaction_entry_category_groups` table
const CATEGORY_COLORS: Record<string, string> = {
    'Bank Fees': '#ECEFFB',
    Donations: '#FFF0F2',
    Entertainment: '#EFF2FC',
    'Food and Drink': '#F2F1F8',
    Government: '#FFF0F2',
    'Health and Wellness': '#FFEAF6',
    Housing: '#FFF4EF',
    Income: '#EBF7E8',
    'Loan Payments': '#EDF1F7',
    Pet: '#F8EEF2',
    'Saving and Investing': '#EDF3F4',
    Services: '#FFEEF4',
    Subscriptions: '#F8EEF2',
    Shopping: '#F8EEF2',
    Transfers: '#EDF5F0',
    Transportation: '#FFF1F1',
    Travel: '#FFF3F0',
    Uncategorized: '#EDF3F4',
    'Work Expenses': '#FFEEF4',
};

export const getIconColor = (categoryGroupName: string) => {
    return CATEGORY_COLORS[categoryGroupName] || '#EDFCE7';
};
